import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M4.625 9A.38.38 0 0 0 5 8.625v-1.25A.403.403 0 0 0 4.625 7h-1.25A.38.38 0 0 0 3 7.375v1.25c0 .219.156.375.375.375h1.25zM8 8.625v-1.25A.403.403 0 0 0 7.625 7h-1.25A.38.38 0 0 0 6 7.375v1.25c0 .219.156.375.375.375h1.25A.38.38 0 0 0 8 8.625zm3 0v-1.25A.403.403 0 0 0 10.625 7h-1.25A.38.38 0 0 0 9 7.375v1.25c0 .219.156.375.375.375h1.25A.38.38 0 0 0 11 8.625zm-3 3v-1.25A.403.403 0 0 0 7.625 10h-1.25a.38.38 0 0 0-.375.375v1.25c0 .219.156.375.375.375h1.25A.38.38 0 0 0 8 11.625zm-3 0v-1.25A.403.403 0 0 0 4.625 10h-1.25a.38.38 0 0 0-.375.375v1.25c0 .219.156.375.375.375h1.25A.38.38 0 0 0 5 11.625zm6 0v-1.25a.403.403 0 0 0-.375-.375h-1.25a.38.38 0 0 0-.375.375v1.25c0 .219.156.375.375.375h1.25a.38.38 0 0 0 .375-.375zM14 3.5c0-.813-.688-1.5-1.5-1.5H11V.375A.403.403 0 0 0 10.625 0h-1.25A.38.38 0 0 0 9 .375V2H5V.375A.403.403 0 0 0 4.625 0h-1.25A.38.38 0 0 0 3 .375V2H1.5A1.5 1.5 0 0 0 0 3.5v11c0 .844.656 1.5 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-11zm-1.5 10.813c0 .124-.094.187-.188.187H1.688c-.125 0-.188-.063-.188-.188V5h11v9.313z",
  fill: "#626262"
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}
export default render